module.exports = __webpack_public_path__ + "static/media/Niveau_elN10_2_563253.330777db.png";